import firebase from 'firebase';
import { IMAGE_UPLOAD_SUCCESSFUL, IMAGE_UPLOAD_FAILURE } from './action-types';

export function uploadImage(file) {
  return (dispatch, getState) => {
    var storageRef = firebase.storage().ref();
    var uploadTask = storageRef.child('images/' + file.name).put(file);
    uploadTask
    .then(
      image => dispatch(imageUploadSuccessful(image))
    )
    .catch(
      error => dispatch(imageUploadFailed(error))
    )
  }

}

export function imageUploadSuccessful(image) {
  return {
    type: IMAGE_UPLOAD_SUCCESSFUL,
    url: image.url
  }
}

export function imageUploadFailed(error) {
  return {
    type: IMAGE_UPLOAD_FAILURE,
    error:error
  }
}



// WEBPACK FOOTER //
// ./src/image-uploader/actions.js